import React from 'react';
import PropTypes from 'prop-types';
import ScheduleInterviewModal from '../../ScheduleInterviewModal';

const getSelectedCoworkers = (interview, possibleInterviewers) => {
  const selectedCoworkers = [];

  interview.attendees.invitees.forEach((attendee) => {
    const coworker = possibleInterviewers.team_members.find(
      (teamMember) => teamMember.email === attendee || teamMember.name === attendee,
    );

    if (coworker) {
      selectedCoworkers.push({ value: coworker.email, label: coworker.name || coworker.email });
    }
  });

  return selectedCoworkers;
};

class EditInterviewModal extends React.Component {
  render() {
    const {
      editInterviewPath,
      csrfToken,
      possibleInterviewers,
      invitableRoles,
      interview,
      editModalRef,
      location,
      disableAvailabilitySelection,
      interviewReschedule,
      resheduleModalRef,
      interviewType,
      newInterviewSlot,
      availableInterviewSlotUrl,
    } = this.props;

    const selectedCoworkers = getSelectedCoworkers(interview, possibleInterviewers);
    const consultantName = interview.attendees.consultant;
    let modalTriggerCopy;
    if (interviewReschedule || interviewType === 'reschedule') {
      modalTriggerCopy = 'Reschedule';
    } else if (disableAvailabilitySelection) {
      modalTriggerCopy = 'Edit Attendees';
    } else {
      modalTriggerCopy = 'Edit Times';
    }

    return (
      <ScheduleInterviewModal
        createInterviewUrl={editInterviewPath}
        csrfToken={csrfToken}
        consultantName={consultantName}
        possibleInterviewers={possibleInterviewers}
        invitableRoles={invitableRoles}
        modalTriggerType="link"
        modalTriggerCopy={modalTriggerCopy}
        modalTriggerClassName="edit-interview-cta"
        availabilities={interview.availabilities}
        timezone={interview.timezone}
        selectedCoworkers={selectedCoworkers}
        excludedInterviewInvitees={[interview.attendees.requester]}
        isEditing
        ref={interviewReschedule ? resheduleModalRef : editModalRef}
        location={location}
        disableAvailabilitySelection={disableAvailabilitySelection}
        interviewReschedule={interviewReschedule}
        interviewType={interviewType}
        rescheduleInterviewPath={interview.reschedule_interview_path}
        newInterviewSlot={newInterviewSlot}
        availableInterviewSlotUrl={availableInterviewSlotUrl}
      />
    );
  }
}

EditInterviewModal.propTypes = {
  editInterviewPath: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  possibleInterviewers: PropTypes.shape({
    current_user_permission: PropTypes.shape({}),
    team_members: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  invitableRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  interview: PropTypes.shape({
    availabilities: PropTypes.arrayOf(PropTypes.shape({})),
    timezone: PropTypes.string,
    attendees: PropTypes.shape({
      consultant: PropTypes.string,
      requester: PropTypes.string,
      invitees: PropTypes.arrayOf(PropTypes.string),
    }),
  }).isRequired,
  editModalRef: PropTypes.func,
  resheduleModalRef: PropTypes.func,
  location: PropTypes.string,
  disableAvailabilitySelection: PropTypes.bool,
  interviewReschedule: PropTypes.bool,
  interviewType: PropTypes.string.isRequired,
  newInterviewSlot: PropTypes.bool,
  availableInterviewSlotUrl: PropTypes.string.isRequired,
};

EditInterviewModal.defaultProps = {
  editModalRef: () => null,
  resheduleModalRef: () => null,
  location: 'Location Not Specified',
  disableAvailabilitySelection: false,
  interviewReschedule: false,
  newInterviewSlot: false,
};

export default EditInterviewModal;
